import React, { useState } from 'react';
import { number, string } from 'prop-types';
import IconAlert from '../shared/icons/IconAlert';
import IconClose from '../shared/icons/IconClose';
import IconCheck from '../shared/icons/IconCheck';

const TargetWarningToast = ({ title, message, type, successCount }) => {
    const [display, setDisplay] = useState('');
    // const closeWarning = () => {
    //     setDisplay('none');
    // };
    
    let successMsg = '';
    if (successCount > 0 && successCount === 1) {
        successMsg = `${successCount} target was ${message}`;
    } else if (successCount > 1) {
        successMsg = `${successCount} targets were ${message}`;
    }
    return (
    <div
        className="de--warning--card"
        style={{ 
            display, 
            backgroundColor: type === 'success' ? '#4FE352' : 'rgba(247, 222, 6, 0.8)',
            marginBottom: '2px',
            height: '49px',
        }}
    >
        {/* {type !== 'error' && (
        <button
            className="de--warning--card__close"
            type="button"
            onClick={closeWarning}
        >
            <IconClose size={8} />
        </button>
        )} */}
        {successCount > 0 ? (<div className="de--warning--card__icon-success">
            <IconCheck />
        </div>) : (<div className="de--warning--card__icon">
            <IconAlert />
        </div>)}
        <div className="de--warning--card__content" style={{ padding: '5px 0', paddingRight: 0 }}>
        <div className="de--warning--card__header" style={{ fontWeight: 400 }}>{title}</div>
        <div className="de--warning--card__message" style={{ fontSize: '11px',fontWeight: 400 }}>
            {successCount > 0 ? successMsg : message}
        </div>
        </div>
    </div>
    );
};


TargetWarningToast.propTypes = {
    title: string,
    message: string, 
    type: string,
    successCount: number,
}

export default TargetWarningToast;